import { render, staticRenderFns } from "./BatchEditor.vue?vue&type=template&id=4ee54bd2"
import script from "./BatchEditor.vue?vue&type=script&lang=js"
export * from "./BatchEditor.vue?vue&type=script&lang=js"
import style0 from "./BatchEditor.vue?vue&type=style&index=0&id=4ee54bd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports